module.exports = __webpack_public_path__ + "static/media/LK_Menu.66fbdadb.svg";